// =============================================================================
// VandieZ admin-web -- shared utilities
// =============================================================================
// `cn()` is the standard shadcn/ui helper: combines clsx (conditional class
// composition) with tailwind-merge (deduplicates conflicting Tailwind
// utilities so e.g. cn("p-2", "p-4") yields "p-4" rather than both).
// =============================================================================

import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
